import type { IBusinessProfile, UpdateBusinessProfileInput } from '@optimus/models';
import { axiosInstance } from './apiConfig';

export const getBusinessProfile = async (companyId: string): Promise<IBusinessProfile> => {
  const { data } = await axiosInstance.get(`/companies/${companyId}/business-profile`);
  return data;
};

export const updateBusinessProfile = async (
  companyId: string,
  input: UpdateBusinessProfileInput,
): Promise<IBusinessProfile> => {
  const { data } = await axiosInstance.post(
    `/companies/${companyId}/business-profile`,
    input,
  );
  return data;
};
